module.exports = __webpack_public_path__ + "img/5.17aa8741.png";